import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseApiClientRisksService } from "src/app/api/base-api-client-risks.service";
import { HttpClientHelperService } from "src/app/api/http-client-helper.service";
import { RiskCatalog, RiskCatalogsResponse, RiskRegistryFilters } from "src/app/api/models/risks/risks.interface";
import { MineSort } from "src/app/shared/mine-sort/mine-sort.interface";
import { Risk } from "src/app/risks/models/risks.interface";
import { AssessmentEditRequest, AssessmentResourceId } from "src/app/api/models/assessments/assessment.interface";

@Injectable({
  providedIn: 'root'
})
export class ApiClientCollaborationRisksService extends BaseApiClientRisksService {
  protected readonly controller: string = 'collaboration/risks';
  protected readonly controllerV4: string = 'assessment/v4/collaboration';

  constructor(httpClientHelper: HttpClientHelperService) {
    super(httpClientHelper);
  }

  override getRisksCatalog(): Observable<RiskCatalogsResponse> {
    return this.httpClientHelper.invokeGetAuth<RiskCatalogsResponse>(`${this.controller}/catalog`);
  }

  override createRiskCatalog(riskCatalog: RiskCatalog): Observable<RiskCatalog> {
    return this.httpClientHelper.invokePostAuth<RiskCatalog>(`${this.controller}/catalog-item`, riskCatalog);
  }

  override getRiskRegistry(search = '', filters: RiskRegistryFilters = null, sort: MineSort = null): Observable<Risk[]> {
    return this.httpClientHelper.invokeGet<Risk[]>(`${this.controllerV4}/risk`, this.getQueryParams(search, filters, sort));
  }

  override createRisk(risk: Risk): Observable<Risk> {
    return this.httpClientHelper.invokePostAuth<Risk>(`${this.controllerV4}/risk`, risk);
  }

  override updateRisk(id: AssessmentResourceId, risks: AssessmentEditRequest[]): Observable<Risk> {
    return this.httpClientHelper.invokePatchAuth<Risk>(`${this.controllerV4}/risk/${id}`, risks);
  }

  override deleteRisk(id: AssessmentResourceId): Observable<void> {
    return this.httpClientHelper.invokeDeleteAuth<void>(`${this.controllerV4}/risk/${id}`);
  }
}
